import { createGameSceneActionListener, GameSceneActionType } from '../../Inamove/Components/GameScene/GameScene'
import GameSceneImage from '../../Inamove/Components/GameSceneImage/GameSceneImage'
import InteractableObject, { createInteractableObjectListener } from '../../Inamove/Components/InteractableObject'
import { levelActionCreator, LevelActionsAction } from '../../Inamove/Components/Level'
import { createTakeableObjectListener } from '../../Inamove/Components/TakeableObject'
import Video from '../../Inamove/Components/Video/Video'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer, {
    createInventoryItemActionListener,
    InventoryActionType,
} from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import LoadingController from '../../Inamove/Controllers/LoadingController'
import delay from '../../Inamove/Utility/delay'
import dispatch from '../../Inamove/Utility/dispatchAction'
import { playVideo } from '../../KUtil/help'

const levelId = 'level8'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    InventoryContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const level = await LevelController.loadLevel(levelId)

    const V16 = new Video(Config.CINEMATIC_PATH + 'V16' + Config.VIDEO_FILE_EXT)
    const V17 = new Video(Config.CINEMATIC_PATH + 'V17' + Config.VIDEO_FILE_EXT)
    const V18 = new Video(Config.CINEMATIC_PATH + 'V18' + Config.VIDEO_FILE_EXT)
    const V19 = new Video(Config.CINEMATIC_PATH + 'V19-ende-friedhof' + Config.VIDEO_FILE_EXT)
    const niesenVideo = new Video(Config.GAME_SCENE_PATH + 'K75/video/K75-niesen' + Config.VIDEO_FILE_EXT)
    ;[V16, V17, V18, V19, niesenVideo].forEach(LoadingController.addToQueue)

    const telefonatAudio = AudioController.add(
        Config.GAME_SCENE_PATH + 'K75/audio/Handy-Dialog-MITTEL' + Config.AUDIO_FILE_EXT
    )
    const friedhofMagazinAudio = AudioController.add(
        Config.GAME_SCENE_PATH + 'K75/audio/Friedhof-Magazin4' + Config.AUDIO_FILE_EXT
    )

    // Boxen von weitem
    const boxenVonWeitemImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K68/K68-boxen.png')
    LoadingController.addToQueue(boxenVonWeitemImage)
    level.gameScenes.K68.addImage(boxenVonWeitemImage)

    const batterienVonWeitemImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K68/K68-batterien.png')
    LoadingController.addToQueue(batterienVonWeitemImage)
    level.gameScenes.K68.addImage(batterienVonWeitemImage)

    const boxenImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K69/K69-I44.png')
    LoadingController.addToQueue(boxenImage)
    level.gameScenes.K69.addImage(boxenImage)

    // spiegel
    const spiegelImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K66/K66-I43.png')
    LoadingController.addToQueue(spiegelImage)
    level.gameScenes.K66.addImage(spiegelImage)

    createInventoryItemActionListener(
        'I44',
        InventoryActionType.added,
        () => {
            level.gameScenes.K68.removeImage(boxenVonWeitemImage, true)
        },
        true
    )

    // hide takeables
    level.gameScenes.K69.hideTakeableObject('boxen1')
    level.gameScenes.K66.hideTakeableObject('spiegel1')
    level.gameScenes.K61.hideTakeableObject('fisch')
    level.gameScenes.K75.hideTakeableObject('magazin1')

    // hide waypoints TODO: hide all ways to K59
    level.gameScenes.K62.hideWaypoint('K59')
    level.gameScenes.K92.hideWaypoint('K59')

    // batterien
    createTakeableObjectListener('batterien', () => {
        batterienVonWeitemImage.hide()
    })

    // Magazin
    const magazinImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K75/K75-Magazin.png')
    LoadingController.addToQueue(magazinImage)
    level.gameScenes.K75.addImage(magazinImage)

    createInventoryItemActionListener('I47', InventoryActionType.added, async () => {
        magazinTaken = true
        level.gameScenes.K75.removeInteractableObject('magazin')
        level.gameScenes.K75.removeImage(magazinImage)

        level.gameScenes.K69.showTakeableObject('boxen1')
        level.gameScenes.K69.removeInteractableObject('boxen')
        level.gameScenes.K69.removeImage(boxenImage)

        level.gameScenes.K66.showTakeableObject('spiegel1')
        level.gameScenes.K66.removeInteractableObject('spiegel')
        level.gameScenes.K66.removeImage(spiegelImage)

        level.gameScenes.K61.showTakeableObject('fisch')

        level.gameScenes.K62.hideWaypoint('K58')
        level.gameScenes.K62.showWaypoint('K59')

        level.gameScenes.K92.hideWaypoint('K58')
        level.gameScenes.K92.showWaypoint('K59')

        await AudioController.play(friedhofMagazinAudio)
    })

    // Niesen
    niesenVideo.hide()
    level.gameScenes.K75.addVideo(niesenVideo)
    const niesenTimeoutMs = 15000
    let magazinTaken = false
    let hasSetAndSpiegel = false

    const niesenTimeOut = async (): Promise<'niesen'> => {
        await delay(niesenTimeoutMs)
        return 'niesen'
    }

    const stopNiesenLogic = () => {
        AudioController.pause(telefonatAudio)
        niesenVideo.hide()
        niesenVideo.skip()
    }

    // nein jetzt nicht videos
    const randomPfarrerVideos = ['pfarrer-random1', 'pfarrer-random2', 'pfarrer-random3', 'pfarrer-random4'].map(
        (id) => new Video(Config.GAME_SCENE_PATH + `K75/video/${id}` + Config.VIDEO_FILE_EXT)
    )
    randomPfarrerVideos.forEach(LoadingController.addToQueue)

    createGameSceneActionListener('K75', GameSceneActionType.enter, async () => {
        // eslint-disable-next-line no-constant-condition
        while (true) {
            if (level.activeGameSceneId !== 'K75') {
                break
            }

            AudioController.resume(telefonatAudio)
            const first = await Promise.race([
                niesenTimeOut(),
                createGameSceneActionListener('K75', GameSceneActionType.leave),
                createInteractableObjectListener('pfarrer'),
                createInteractableObjectListener('pfarrer1'),
            ])

            if (first === 'niesen') {
                const K75 = level.gameScenes.K75

                // change GameScene
                if (!magazinTaken) {
                    K75.showTakeableObject('magazin1')
                    K75.hideInteractableObject('magazin')
                }
                hasSetAndSpiegel ? K75.hideInteractableObject('pfarrer1') : K75.hideInteractableObject('pfarrer')

                AudioController.pause(telefonatAudio)

                // play video
                niesenVideo.show()
                await niesenVideo.play()
                niesenVideo.hide()

                // reset GameScene
                hasSetAndSpiegel ? K75.showInteractableObject('pfarrer1') : K75.showInteractableObject('pfarrer')

                if (!magazinTaken) {
                    K75.hideTakeableObject('magazin1')
                    K75.showInteractableObject('magazin')
                }
            } else if (first instanceof InteractableObject && first.id === 'pfarrer') {
                // pfarrer
                AudioController.pause(telefonatAudio)
                await playVideo(randomPfarrerVideos[Math.floor(Math.random() * randomPfarrerVideos.length)])
            } else if (first instanceof InteractableObject && first.id === 'pfarrer1') {
                // ende
                stopNiesenLogic()
                // play video of creating the illusion
                level.stopGame()
                AudioController.setMute(true)
                await playVideo(V18)
                AudioController.setMute(false)
                // Pfarrer dialog
                await level.startDialog('D6')
                AudioController.setMute(true)
                // End video
                await playVideo(V19)
                AudioController.setMute(false)

                dispatch(levelActionCreator(level, LevelActionsAction.stop))

                break
            } else {
                // leave GameScene
                break
            }
        }
    })

    createGameSceneActionListener('K75', GameSceneActionType.leave, stopNiesenLogic)

    const hasSet = createInventoryItemActionListener('I56', InventoryActionType.added)
    const hasSpiegel = createInventoryItemActionListener('I43', InventoryActionType.added)

    // has Set & has Spiegel
    Promise.all([hasSet, hasSpiegel]).then(() => {
        hasSetAndSpiegel = true
        level.gameScenes.K75.hideInteractableObject('pfarrer')
        level.gameScenes.K75.showInteractableObject('pfarrer1')
    })
    level.gameScenes.K75.hideInteractableObject('pfarrer1')

    // Homer Dialogs
    createInteractableObjectListener('D7', async () => {
        level.stopGame()
        await level.startDialog('D7')
        level.startGame()
    })

    createInteractableObjectListener('dialog', async (InteractableObject) => {
        if (InteractableObject.interactData?.action === 'D8') {
            level.stopGame()
            await level.startDialog('D8')
            level.startGame()
        }
    })

    await AudioController.addAllToLoadingQueue()
    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    // initialize telefonat so we can freely pause and resume later
    AudioController.loop(telefonatAudio)
    AudioController.pause(telefonatAudio)

    LoadingContainer.hide()
    CinematicContainer.setVideo(V16)
    CinematicContainer.show()
    await CinematicContainer.play()
    CinematicContainer.hide()
    GameSceneContainer.show()
    InventoryContainer.show()

    LevelController.startLevel(levelId)

    return new Promise<void>((resolve) => {
        addEventListener('Level', (event) => {
            // @ts-ignore
            const action: LevelActionsAction = event.detail.action
            // @ts-ignore
            const level: Level = event.detail.level

            if (action === LevelActionsAction.stop && level.id === levelId) {
                resolve()
            }
        })
    })
}
